import { type ReactNode, useState } from 'react';
import { Button } from '@/components/ui/button';
import type { AccountStatus, Approacher } from '../types';
import { useStatusOverride } from '../hooks/use-status-override';
import { StatusOverrideForm } from './status-override-form';
import { RedemptionResetCard } from './redemption-reset-card';

type FS = { status: AccountStatus; reason: string; confirmed: boolean };
type Props = { a: Approacher; onClose: () => void };

function useStatusForm(a: Approacher, onClose: () => void) {
  const [s, setS] = useState<FS>({
    status: a.account_status,
    reason: '',
    confirmed: false,
  });
  const m = useStatusOverride();
  const isUnban = s.status !== 'banned' && a.account_status === 'banned';
  const submit = (): void => {
    m.mutate(
      { id: a.id, status: s.status, reason: s.reason, force: isUnban },
      { onSuccess: onClose }
    );
  };
  return { s, setS, submit, isPending: m.isPending };
}

export function StatusEditBar({ a, onClose }: Props): ReactNode {
  const { s, setS, submit, isPending } = useStatusForm(a, onClose);
  return (
    <div className="space-y-sm border-t border-white/[0.06] pt-base">
      <div className="flex items-center justify-between">
        <h3 className="text-[10px] uppercase tracking-wider text-text-tertiary/60">
          Editar estado
        </h3>
        <Button variant="ghost" size="sm" onClick={onClose}>
          Cancelar
        </Button>
      </div>
      <StatusOverrideForm
        s={s}
        setS={setS}
        current={a.account_status}
        isPending={isPending}
        onSubmit={submit}
      />
      {a.has_used_redemption && <RedemptionResetCard memberId={a.id} />}
    </div>
  );
}
